import React, { useEffect } from "react";

// Limpia a solo digitos y, si sobran mas de 10, se queda con los ULTIMOS 10 -- asi un
// numero ya guardado con codigo de pais ("+52 961 709 5306", "5219617095306") o pegado
// con formato se recorta al numero real en vez de perder los ultimos digitos.
function cleanDigits(raw) {
  return (raw || "").replace(/\D/g, "").slice(-10);
}

// Validacion de captura humana (Bloque 2C) -- SOLO para el frontend. El backend sigue
// aceptando 10/12/13 digitos (normalize_phone en phones.py), esto no lo toca ni lo endurece.
export function phoneDigitsValid(digits, required) {
  const clean = digits || "";
  if (!clean) return !required;
  return clean.length === 10;
}

export default function PhoneInput({ value, onChange, required = false, className = "input", placeholder, testId }) {
  const digits = cleanDigits(value);

  // Si el valor que llega de afuera (ej. un telefono ya guardado con formato viejo)
  // trae algo distinto a los 10 digitos limpios, normaliza el estado del formulario --
  // sin esto, un "Guardar" sin tocar el campo mandaria el valor sucio original.
  useEffect(() => {
    if (digits !== (value || "")) onChange(digits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (e) => onChange(cleanDigits(e.target.value));

  const handleKeyDown = (e) => {
    const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab", "Home", "End"];
    if (allowed.includes(e.key) || e.ctrlKey || e.metaKey || e.altKey) return;
    if (!/^[0-9]$/.test(e.key)) e.preventDefault();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    onChange(cleanDigits(pasted));
  };

  const complete = digits.length === 10;
  const counterColor = complete ? "text-emerald-600" : required ? "text-amber-600" : "text-slate-400";

  return (
    <div>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        className={className}
        value={digits}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        placeholder={placeholder || "10 dígitos"}
        data-testid={testId}
      />
      <div className={`mt-1 text-xs ${counterColor}`}>{digits.length}/10 dígitos</div>
    </div>
  );
}
